import { useQuery } from '@tanstack/react-query'

import { auditLogGridContract, createDataGridClient } from '@/modules/data-grid'

const RECENT_LIMIT = 8
const CHANGE_ACTIONS = Object.keys(auditLogGridContract.columns.action.labels).filter((action) => action !== 'VIEW')

export function useRecentActivity(entityId: string) {
  return useQuery({
    queryKey: ['audit', 'recent-activity', entityId],
    queryFn: ({ signal }) => createDataGridClient({
      contract: auditLogGridContract,
      endpoint: `/api/v1/entities/${entityId}/audit-log`,
    }).query({
      query: {
        columns: ['timestamp', 'entity', 'details', 'actor'],
        filter: [{ column: 'action', operator: 'in', values: CHANGE_ACTIONS }],
        sort: auditLogGridContract.defaultSort,
        pagination: { limit: RECENT_LIMIT },
      },
      signal,
    }),
  })
}
